import React from "react";
import BlankStateV2 from "@ui/BlankStateV2";
import ScreenGraph from "@ui/Picto/ScreenGraph";
import t from "../../../../i18n";

const BlankStateMeasures = () => (
  <BlankStateV2
    title={t("measures.empty.title")}
    subtitle={t("commons.no_quantities_yet.text")}
    picto={<ScreenGraph />}
  />
);
export default BlankStateMeasures;
